import React from "react";

import Specifications from "../Specifications/Specifications";
import {Link} from "react-router-dom";

const Person = ({
    person
}) => {
    const { name, title, socials, work, stats } = person;

    return (
        <>
            <div className="person">
                <div className="container">
                    <div className="grid">
                        <div>
                            <div className="panel">
                                <h3>{name}</h3>
                                <p><small>{title}</small></p>
                                <div className="socials-icons">
                                    {socials.map((social, key) => (
                                        <Link to={social.url} target="_blank" rel="noopener noreferrer" key={key}>
                                            <i className={social.icon}></i>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div>
                            <h2>EXPERIENCE</h2>
                            <Specifications dataset={work} cols={3} />
                            <h2>STATS</h2>
                            <Specifications dataset={stats} cols={4} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Person;